import script from "./SimpleSelectTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleSelectTrigger.vue?vue&type=script&setup=true&lang=js"

import "./SimpleSelectTrigger.vue?vue&type=style&index=0&id=583e92a1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583e92a1"]])

export default __exports__